import script from "./SubmitButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitButton.vue?vue&type=script&setup=true&lang=js"

import "./SubmitButton.vue?vue&type=style&index=0&id=48cf8974&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48cf8974"]])

export default __exports__